// extracted by mini-css-extract-plugin
module.exports = {"word":"Hangman_word__1VxZs","letterInput":"Hangman_letterInput___vPrv"};